import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgFormErrorsComponent } from './ng-form-errors.component'
import { ObjectToArrayPipe } from './object-array-pipe'
import { PropertyNamesPipe } from './property-name-pipe'
import { PropertyValuesPipe } from './property-value-pipe'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    NgFormErrorsComponent,
    ObjectToArrayPipe,
    PropertyNamesPipe,
    PropertyValuesPipe
  ],
  exports: [NgFormErrorsComponent]
})
export class NgFormErrorsModule { }
